import { useEffect, useState } from 'react';
import './AlcanceTotalEMensal.css';

import toast from 'react-hot-toast';

import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { XAxis, YAxis, Tooltip, Legend } from 'recharts';
import { BarChart, Bar } from 'recharts';



function AlcanceTotalEMensal({ dadosGrafPeriodo, dadosGrafMensal }) {

    console.log('### Iniciando AlcanceTotalEMensal ###');

    // Cores pie chart
    const COLORS = ['#0088FE', '#FFB703'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    }

    return (
        <div className='h-100 div-com-borda p-1 d-flex flex-column flex-md-row'>
            <div className='col-12 col-sm-2 text-center'>
                <p>Percentual total de alcance</p>
                <ResponsiveContainer width="100%" height="80%">
                    <PieChart >
                        <Pie
                            data={dadosGrafPeriodo}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={renderCustomizedLabel}
                            dataKey="value"
                        >
                            {dadosGrafPeriodo.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div className='aligm-center col-12 col-sm-10 text-center'>
                <p>Percentual mensal de alcance</p>
                <ResponsiveContainer width="100%" height="80%">
                    <BarChart
                        data={dadosGrafMensal}
                        margin={{
                            left: 0,
                            right: 30
                        }}
                    >
                        <XAxis dataKey="mesReferencia" />
                        <YAxis />
                        <Tooltip />
                        <Bar
                            dataKey="alcanceMensal"
                            stackId="as"
                            fill="#0088FE"
                            label={{ fill: "white", fontSize: 15 }}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default AlcanceTotalEMensal
